module.exports = __webpack_public_path__ + "static/48a5a2a0e94059418865c459aa42d2e0e8dec7369978c36890dc7eae067598e4-a2cc3ae69136700032c64041bb3706c3.jpeg";